
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { TRANSLATIONS_FETCH } from "@/store/ActionTypes";
import UserRepository from "@/utils/API/UserRepository";

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    })
  },
  components: {}
})
class ResetPassword extends Vue {
  localizationState: any;

  password: string = "";
  confirmPassword: string = "";

  resetPassword() {
    this.$validator.validateAll('resetPass').then((result) => {
      if (result) {
        // @ts-ignore
        this.$snotify.async(
          this.translations.get("password_resetting"),
          () =>
            new Promise((resolve, reject) => {
              UserRepository.resetPassword({
                password: this.password,
                confirmPassword: this.confirmPassword,
                token: this.$route.params.token
              })
                .then(() => {
                  this.$router.push("/login");
                  resolve({
                    body: `${this.translations.get("password_reset")}`
                  });
                })
                .catch((error) => {
                  let message = "";
                  if (error.response) {
                    message =
                      error.response.data.errorMessages[0].userVisibleMessage;
                  }
                  else {
                    message = this.translations.get("network_error");
                  }
                  reject({ body: message });
                });
            }),
          {
            timeout: 3500,
            closeOnClick: true
          }
        );
        return;
      }
      this.$snotify.error(this.translations.get("validation-error-message"));
    });
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    this.$store.dispatch(TRANSLATIONS_FETCH, {
      category: "pages",
      collections: ["common"]
    }).then(()=>{
      document.title = this.translations.get("reset_password")+' '+this.translations.get("meta_title_postfix");
    });

    UserRepository.validateResetPasswordToken({
      token: this.$route.params.token
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        this.$router.push("/login");
      });
  }
}
export default ResetPassword;
